export const downloadExportFile = (file: File, options: { name: string; type: string }) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob([file]));
    downloadLink.download = `${options.name}.${options.type.toLowerCase()}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};
